import { render, staticRenderFns } from "./assessTarget.vue?vue&type=template&id=694fc074&scoped=true"
import script from "./assessTarget.vue?vue&type=script&lang=js"
export * from "./assessTarget.vue?vue&type=script&lang=js"
import style0 from "./assessTarget.vue?vue&type=style&index=0&id=694fc074&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694fc074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694fc074')) {
      api.createRecord('694fc074', component.options)
    } else {
      api.reload('694fc074', component.options)
    }
    module.hot.accept("./assessTarget.vue?vue&type=template&id=694fc074&scoped=true", function () {
      api.rerender('694fc074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/workbench/components/assessTarget.vue"
export default component.exports